import { ref, onMounted, onUnmounted } from 'vue'

function useScreenOrientation() {
  const isLandscape = ref(window.matchMedia('(orientation: landscape)').matches)

  let mediaQuery: MediaQueryList

  const handleOrientationChange = (e: MediaQueryListEvent) => {
    isLandscape.value = e.matches
  }

  onMounted(() => {
    mediaQuery = window.matchMedia('(orientation: landscape)')
    mediaQuery.addEventListener('change', handleOrientationChange)
  })

  onUnmounted(() => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', handleOrientationChange)
    }
  })

  return { isLandscape }
}

export { useScreenOrientation }
